import type { Prototype } from "../prototype-types";

export const aneleseWebskiPrototypes: Prototype[] = [
  {
    id: "awe-pdp-brand-refinement-accent-colors",
    name: "PDP Brand Refinement Accent Colors",
    path: "/awe/pdp-brand-refinement-accent-colors",
    description: "",
    owner: "Anelese Webski",
    createdAt: "2026-06-11",
    lastUpdated: "2026-06-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/42fc977b0e2f3b19c6511a7a046d1cc0730bceaf6bd412a0b5f2c3f05f9927e9.png",
    creationTool: "claude-code",
  },
  {
    id: "awe-price-verification-good-margin-flag",
    name: "Price Verification &amp; Good Margin Flag",
    path: "/awe/price-verification-good-margin-flag",
    description: "",
    owner: "Anelese Webski",
    createdAt: "2026-07-06",
    lastUpdated: "2026-07-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/993f1af5d43a3cacb06bf43b2f5ed6c885e313adf544bfbe7b83c94521d52d44.png",
    creationTool: "claude-code",
  },
  {
    id: "awe-brand-product-insights",
    name: "Brand &amp; Product Insights",
    path: "/awe/brand-product-insights",
    description: "Synthesis of moderated + unmoderated research on brand &amp; product discovery signals (Evaluate Pod, Q3 2026)",
    owner: "Anelese Webski",
    createdAt: "2026-07-21",
    lastUpdated: "2026-07-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/bc3ab3d0a30d9f492f9e8b616dacdc9c0094e7f65908f35aaa09eec303af4ee5.png",
    creationTool: "claude-code",
  },
  {
    id: "awe-bp-cat-nav-explorations",
    name: "BP Cat Nav Explorations",
    path: "/awe/bp-cat-nav-explorations",
    description: "Brand page category-nav explorations: ten layout variants for the filter and category navigation (collapsing rail, filter drawer, category pill, featured tabs, inset and full-bleed headers, sticky rail, pills above the grid), on a line-sheet list view carrying the PDP brand order-minimum progress tracker.",
    owner: "Anelese Webski",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/awe-bp-cat-nav-explorations.png",
    creationTool: "claude-code",
  },
  {
    id: "awe-top-reordered-list-page",
    name: "Top Reordered List Page",
    path: "/awe/top-reordered-list-page",
    description:
      "A 'Top reordered in Bath & body' landing page, entered from a reorder badge on the retailer PDP. Four badge treatments switch from the toolbar; the list ranks the category by repeat-purchase rate.",
    owner: "Anelese Webski",
    createdAt: "2026-09-10",
    lastUpdated: "2026-09-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/awe-top-reordered-list-page.png",
    creationTool: "claude-code",
  },
];
